import React from 'react';
import classNames from 'classnames';

import { Icon } from 'admin/components/common/Icon';

import css from './MessageContainer.scss';

type Props = {
	content: React.ReactNode | string;
	messageType: string;
	duration: number;
};

const MessageContainer = ({ content, messageType, duration }: Props) => (
	<div className={classNames(css.messageContent, css[messageType])} style={{ animationDuration: `${duration}s` }}>
		<Icon type={icon[messageType]} width={18} color="white" />
		{React.isValidElement(content) ? content : <p>{content}</p>}
	</div>
);

MessageContainer.ERROR = 'error';
MessageContainer.SUCCESS = 'success';
MessageContainer.INFO = 'info';
MessageContainer.WARN = 'warn';
MessageContainer.CSS = css;

const icon = {
	[MessageContainer.SUCCESS]: 'done-all',
	[MessageContainer.ERROR]: 'info',
	[MessageContainer.WARN]: 'info',
	[MessageContainer.INFO]: 'info',
};

export default MessageContainer;
